// extracted by mini-css-extract-plugin
module.exports = {"ListCard":"Admin_ListCard__1mGRK","ListCardBody":"Admin_ListCardBody__2BXOi","titleMarginBottom":"Admin_titleMarginBottom__3rkOf"};